var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-container"},[_c('p',[_vm._v("Step "+_vm._s(_vm.current_step)+" of "+_vm._s(_vm.total_steps))])])}
var staticRenderFns = []

export { render, staticRenderFns }